module.exports = __webpack_public_path__ + "static/media/galerija_2014 (5).3fb2ce39.jpg";